import { render, staticRenderFns } from "./comCarousel.vue?vue&type=template&id=7fc83250&scoped=true&"
import script from "./comCarousel.vue?vue&type=script&lang=js&"
export * from "./comCarousel.vue?vue&type=script&lang=js&"
import style0 from "./comCarousel.vue?vue&type=style&index=0&id=7fc83250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc83250",
  null
  
)

export default component.exports